// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__YfZN9","approved":"Status_approved__3Xapy","rejected":"Status_rejected__389Zw","expired":"Status_expired__sz49c","label":"Status_label__2c9lq"};